import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetFitnessStatisticsReportReqData } from "./GetFitnessStatisticsReportReqData";
import { GetFitnessStatisticsReportResData } from "./GetFitnessStatisticsReportResData";

const ENDPOINT = "/fitness_statistics/report";

export class GetFitnessStatisticsReportCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetFitnessStatisticsReportReqData = null;

    constructor(params: GetFitnessStatisticsReportReqData) {
        super();
        this.params = Object.assign({}, params);
    }

    public async execute(): Promise<GetFitnessStatisticsReportResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetFitnessStatisticsReportResData(res);
    }
}
